import React from 'react';
import FundingDealCard from './FundingDealCard';

const FundingDealStageColumn = ({ stage, deals, onSelectDeal, onStageChange, onCreateCommission, creatingCommissionId, saving }) => (
  <div className="min-w-[280px] flex-1 rounded-2xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] p-4">
    <div className="mb-4">
      <div className="text-sm font-semibold text-[var(--fg-text)]">{stage}</div>
      <div className="mt-1 text-xs font-medium text-[var(--fg-accent)]">{deals.length} deals</div>
    </div>
    <div className="space-y-3">
      {deals.length === 0 ? (
        <p className="text-sm text-[var(--fg-muted)]">No deals in this stage.</p>
      ) : (
        deals.map((deal) => (
          <FundingDealCard
            key={deal.id}
            deal={deal}
            onSelect={onSelectDeal}
            onStageChange={onStageChange}
            onCreateCommission={onCreateCommission}
            creatingCommission={creatingCommissionId === deal.id}
            saving={saving}
          />
        ))
      )}
    </div>
  </div>
);

export default FundingDealStageColumn;
